import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { riverStone, IMG } from "@/data/brand";

// Official multi-color Google "G" mark (inline SVG so it stays crisp)
const GoogleG = ({ size = 26 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
  </svg>
);

export const GoogleReviewsBand = () => (
  <section data-testid="google-reviews-band" className="relative overflow-hidden bg-[#0a0908] py-28 md:py-36 grain">
    {/* Background image + wash */}
    <motion.img
      src={IMG.cocktail} alt=""
      aria-hidden="true"
      className="absolute inset-0 w-full h-full object-cover opacity-25"
      initial={{ scale: 1.15 }} whileInView={{ scale: 1 }} viewport={{ once: true }}
      transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
    />
    <div className="absolute inset-0 bg-gradient-to-t from-[#0a0908] via-[#0a0908]/85 to-[#0a0908]/70" />

    <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
      <Reveal>
        <span className="text-[10px] tracking-[0.4em] uppercase text-[#c5a059]">Guest Reviews</span>
      </Reveal>

      <Reveal delay={0.08}>
        <div className="mt-7 flex items-center justify-center gap-3">
          <span className="w-14 h-14 rounded-full bg-white flex items-center justify-center shadow-lg">
            <GoogleG size={28} />
          </span>
          <span className="font-serif text-2xl md:text-3xl text-white/90">Reviewed on Google</span>
        </div>
      </Reveal>

      <Reveal delay={0.14}>
        <h2 className="font-serif font-light text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05] mt-9">
          Loved by our guests across<br className="hidden sm:block" /> Coastal Virginia
        </h2>
      </Reveal>

      <Reveal delay={0.2}>
        <p className="text-white/55 font-light text-base md:text-lg leading-relaxed mt-6 max-w-xl mx-auto">
          From the dry-aged steaks to the raw bar and the room itself — hear what guests are saying about their evenings at River Stone.
        </p>
      </Reveal>

      <Reveal delay={0.26}>
        <a
          href={riverStone.googleReviewsUrl}
          target="_blank"
          rel="noreferrer"
          data-testid="google-reviews-cta"
          className="group mt-10 inline-flex items-center gap-3 bg-[#c5a059] text-[#0a0908] px-9 py-4 text-[11px] font-semibold tracking-[0.25em] uppercase hover:bg-[#b08d4a] transition-colors duration-300"
        >
          Read Our Reviews on Google
          <ArrowUpRight size={16} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
        </a>
      </Reveal>
    </div>
  </section>
);
